<template>
    <div class="dialog-content" style="background-color: rgba(41, 155, 255, .1);width: 100%;padding-top: 10px;">

      <!--操控-->
      <div class="pl-4">
        <div v-for="(item) in access" :key="item.devSn" class="mb-1">
          <el-tooltip v-for="door in item.door" :key="door.did" content="点击即可开门" effect="dark" placement="top">
            <el-button size="mini" @touchstart="sendOpenDoor(item.devSn,door.did)" @click="sendOpenDoor(item.devSn,door.did)">
              {{ door.area_name ? door.area_name : '' }} {{ door.area_name && door.name ? ':' : '' }}
              {{ door.name ? door.name : '' }}
            </el-button>
          </el-tooltip>
        </div>
      </div>
      <!--      开门记录-->
      <el-row style="padding: 20px">
        <el-table
          :data="doorLogs.data"
          :height="tableHeight"
          border
          class="m-auto"
          style="width: 100%;">
          <!--          <el-table-column-->
          <!--              align="center"-->
          <!--              label="员工名"-->
          <!--              prop="name">-->
          <!--          </el-table-column>-->
          <el-table-column
            align="center"
            label="工号"
            prop="number">
          </el-table-column>
          <!--          <el-table-column-->
          <!--              align="center"-->
          <!--              label="部门名称"-->
          <!--              prop="section">-->
          <!--          </el-table-column>-->
          <el-table-column
            align="center"
            label="记录类型"
            prop="log">
          </el-table-column>
          <el-table-column
            align="center"
            label="门名称"
            prop="door"
            width="300">
          </el-table-column>
          <el-table-column
            align="center"
            label="开门时间"
            prop="time">
          </el-table-column>
        </el-table>
      </el-row>
      <el-pagination
        :current-page="doorLogs.index + 1" :hide-on-single-page="true"
        :page-size="doorLogs.size"
        :small="true"
        :total="doorLogs.count"
        class="mb-4 mt-3 text-center"
        layout="prev, pager, next"
        style="padding-left: 35px;width: 92%;"
        @current-change="pageChange">
      </el-pagination>
    </div>
</template>

<script>
import {passwordVerifiers} from "@/network/account";
import {getCookie, setCookie} from "@/utils/common";

export default {
  name: "Door",
  props: ['deviceInfo', 'alarmInfoList'],
  data() {
    return {
      websocket: null,
      // 开门记录
      doorLogs: {},
      // 控制器列表
      access: [],
      // 获取开门记录的请求参数
      doorGetSetting: {
        command: 'getLogs',
        data: {
          max: 10,
          index: 0
        },
      },
    }
  },
  computed: {
    tableHeight() {
      return window.innerHeight * 0.40
    }
  },
  mounted() {
    this.initDoorWebsocket()
  },
  destroyed() {
    if (this.websocket) {
      this.websocket.close()
      this.websocket = null
    }
  },
  methods: {
    // 翻页
    pageChange(page) {
      this.doorGetSetting.data.index = page - 1
      this.sendGetLogs()
    },
    initDoorWebsocket() {
      if (this.websocket) {
        this.websocket.close()
        this.websocket = null
      }
      let properties = JSON.parse(this.deviceInfo.portProperties)
      // this.websocket = new WebSocket('wss://' + window.g.domain + ":" + properties.PORT + '?ip=' + properties.IP)
      this.websocket = new WebSocket('ws://' + properties.IP + ':' + properties.PORT)
      // 连接成功
      this.websocket.onopen = () => {
        this.sendGetLogs()
        this.sendFindAccess()
      }
      // 消息回调
      this.websocket.onmessage = (e) => {
        let websocketObj = JSON.parse(e.data)
        this[websocketObj.command](websocketObj)
      }
    },
    // 发送获取开门记录命令
    sendGetLogs() {
      if (this.websocket) {
        this.websocket.send(JSON.stringify(this.doorGetSetting))
      }
    },
    // 发送获取控制器列表命令
    sendFindAccess() {
      if (this.websocket) {
        this.websocket.send(JSON.stringify({command: 'getAccess'}))
      }
    },
    // 发送开门命令
    sendOpenDoor(devSn, did) {
      if(getCookie("passwordVerification") === '1'){
        if (this.websocket) {
          this.websocket.send(JSON.stringify({command: 'openDoor', data: {devSn, did}}))
        }
      }else{
        this.$prompt('请输入系统登录密码确认身份', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'password',
        }).then(({value}) => {
          passwordVerifiers(value).then(res =>{
            if (res.data === true){
              setCookie("passwordVerification",'1',null);
              if (this.websocket) {
                this.websocket.send(JSON.stringify({command: 'openDoor', data: {devSn, did}}))
              }
              this.functionDialogVisible = false;
            }else{
              this.$message({
                message: '系统登录密码错误',
                type: 'warning'
              });
              return;
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '取消输入'
          });
        });
      }
    },
    // 获取开门记录回调
    getLogs(data) {
      this.doorLogs = data
    },
    // 获取控制器列表回调
    getAccess(data) {
      this.access = data.data
    },
    // 开门回调
    openDoor(data) {
      if ('OK' === data.info.result) {
        this.$message.success("控制开门成功")
      } else {
        this.$message.error("控制开门失败")
      }
    }
  }
}
</script>

<style scoped>

</style>
